import { render, staticRenderFns } from "./ProfileMedia.vue?vue&type=template&id=8b3e1b1e&scoped=true"
import script from "./ProfileMedia.vue?vue&type=script&lang=js"
export * from "./ProfileMedia.vue?vue&type=script&lang=js"
import style0 from "./ProfileMedia.vue?vue&type=style&index=0&id=8b3e1b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3e1b1e",
  null
  
)

export default component.exports